module.exports = __webpack_public_path__ + "static/the-5-elements-of-effective-thinking-3669e5a079b179e60177b879220a8536.jpg";